export const GLOBAL_SETTINGS_STORAGE_KEY = "globalSettings";
export const AUTHORIZATIONS_STORAGE_KEY = "authorizations";
export const AUTH_TOKEN_STORAGE_KEY = "authToken";
// Bumped (timestamp written) whenever an in-tab session mutation lands —
// MFA verify / enroll, primarily. The `storage` event fires only in OTHER
// tabs, giving us a free cross-tab signal to invalidate the session +
// authUser queries so a tab still parked on /verify-mfa picks up the new
// `mfa_required: false` state without polling or focus heuristics. The
// value is a monotonically-increasing string (Date.now()) — only the
// change matters, never the contents.
export const SESSION_UPDATED_AT_STORAGE_KEY = "alliai.v1.sessionUpdatedAt";
export const PENDING_INVITE_UUID_STORAGE_KEY = "alliai.v1.pendingInviteUuid";
export const HUBSPOT_TOKEN_COOKIE_KEY = "hubspotutk";
export const REGISTRATION_PARAMS_STORAGE_KEY = "registration_params";

export const COMMON_HEADERS = {
  Accept: "application/json",
  "Content-Type": "multipart/form-data",
};
export const FORM_HEADERS = {
  Accept: "multipart/form-data",
  "Content-Type": "multipart/form-data",
};

export const CRAWLER_FILE_TYPES = ["CSV"];
export const CRAWL_MODE = {
  WHITELISTED: "whitelisted",
  NORMAL: "normal",
};
// Mirrors Site::UNLIMITED_PLAN_PAGE_BUDGET on the backend: sites on
// usage-billed plans (no page cap, serialized as null) default to a
// 1,000-page crawl budget so the per-page bill stays bounded.
export const UNLIMITED_PLAN_PAGE_BUDGET = 1000;
// Piecewise slider scale for page counts on unlimited plans: fine steps
// around typical budgets, denser value ranges toward the right so large
// sites (100–200k pages) stay reachable.
export const UNLIMITED_PAGE_SCALE = [
  0, 500, 1000, 2500, 5000, 10000, 25000, 50000, 100000, 200000,
];
export const CATEGORY_AUTOMATION_KIND = "automation";
export const TEAM_PRERENDERING_EDGE_FEATURE_KEY = "prerendering-edge";
export const STRIPE_SESSION_AUTO_OPEN_KEY = "stripe-session-auto-open";
export const ALLI_AI_BRAND_NAME = "Alli AI";
export const ALLI_VERIFICATION_NAME = "_alliai-challenge";
export const ALLI_TENANT_UUID_HEADER = "X-AlliAi-Tenant";
export const ALLI_WP_PLUGIN_DOWNLOAD_URL =
  "https://www.alliai.com/wp-content/uploads/alli-ai-visibility-engine-1.0.2.zip";
export const REQUEST_DEMO_URL = "https://www.alliai.com/demo";
export const ALLI_TERMS_OF_SERVICE_URL =
  "https://www.alliai.com/terms-of-service";
